import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

export function RequireAuth() {
  const location = useLocation();
  const authed = useAuthStore((s) => Boolean(s.accessToken && s.refreshToken));

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
